function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "58",
  height: "64",
  viewBox: "0 0 58 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.398 41.25c11.708 3.704 23.5 2.795 31.957-1.886 8.402-4.65 13.582-13.047 12.184-24.62l1.985-.24c1.5 12.42-4.119 21.583-13.2 26.61-9.026 4.995-21.401 5.88-33.53 2.042l.604-1.907z",
  fill: "#01C38F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.784 23.365l4.804-6.592 2.04-.396 6.92 4.316-.539-2.775-8.125-5.065-5.639 7.736.54 2.776z",
  fill: "#01C38F"
})));